export default __webpack_public_path__ + "static/media/AT-2020-16-5.6c72212f.png";